import {
    createReducer,
    createNamespacer,
} from "../../commons/js/utils/reducer";

const initialState = {
    searchKey: "",
    isLoading: false,
    hangerShopPackages: [],
    facilitiesList: [],
    materialList: [],
    selectedFacility: { value: "", label: "All Facilities" },
    material: { value: "", label: "All Materials" },
};

const namespacers = {
    hangerShop: createNamespacer("HANGER_SHOP"),
};

const reducer = createReducer(initialState, {
    [namespacers.hangerShop("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        };
    },
    [namespacers.hangerShop("SET_HANGER_SHOP_PACKAGES")]: (state, action) => {
        return {
            ...state,
            hangerShopPackages: action.payload.value,
        };
    },
    [namespacers.hangerShop("SET_PAGE_NUMBER")]: (state, action) => {
        return {
            ...state,
            pageNumber: action.payload.pageNumber,
        };
    },
    [namespacers.hangerShop("SET_TOTAL_PAGES")]: (state, action) => {
        return {
            ...state,
            totalPages: action.payload.totalPages,
        };
    },
    [namespacers.hangerShop("STORE_SEARCH_KEY")]: (state, action) => {
        return {
            ...state,
            searchKey: action.payload.value,
        };
    },
    [namespacers.hangerShop("SET_ACTIVE_FACILITITES")]: (state, action) => {
        return {
            ...state,
            facilitiesList: action.payload.facilitiesList,
        };
    },
    [namespacers.hangerShop("SET_SELECTED_FACILITY")]: (state, action) => {
        return {
            ...state,
            selectedFacility: action.payload.value,
        };
    },
    [namespacers.hangerShop("SET_MATERIALS_LIST")]: (state, action) => {
        return {
            ...state,
            materialList: action.payload.value,
        };
    },
    [namespacers.hangerShop("SET_SELECTED_MATERIAL")]: (state, action) => {
        return {
            ...state,
            material: action.payload.value,
        };
    },
});

export default reducer;
